import React from 'react';
import { Button } from '@themesberg/react-bootstrap';
import useEditFormCancel from '../hooks/useEditFormCancel';

const EditFormActions = ({
  backTo,
  isDirty = false,
  saveDisabled = false,
  saveLabel = 'Save',
  isSubmitting = false,
  onCancel,
}) => {
  const defaultCancel = useEditFormCancel(backTo, isDirty);
  const handleCancel = onCancel || defaultCancel;

  return (
    <div className="edit-form-actions">
      <Button
        variant="primary"
        type="submit"
        className="edit-form-actions__save btn-quote-blue box-shedow-none outline-none"
        disabled={saveDisabled || isSubmitting}
      >
        {isSubmitting ? 'Saving...' : saveLabel}
      </Button>
      <Button
        variant="outline-secondary"
        type="button"
        className="edit-form-actions__cancel btn-quote-cancel box-shedow-none outline-none"
        onClick={handleCancel}
      >
        Cancel
      </Button>
    </div>
  );
};

export default EditFormActions;
